
<div *ngIf="LX" class="btn-track px-3 py-2 typo-chip deck-LX" [ngClass]="{ 'active' : isL0 ? productService.L0 === LX : productService.L1 === LX }" (click)="onDeckClicked()">
    <!--
        <img *ngIf="isL0" class="picto-chip me-2" src="../../../assets/images/231116/pictos/{{ LX.Title }}.svg" />
    -->
    <span class="">{{ LX.Id | translate }}</span>
</div>